import React, { Component } from 'react';
import "./threeSquareImageGrid.css";

export default class extends Component {
  constructor(props) {
      super(props);
      this.state = {
          componentReady: 'ready'
      };
  }

  removeGrid = () => {
    this.refs.imageGrid.remove();
  }
  render() {
    return (
      <div className="three-square-image-grid-container">
        <div ref={"imageGrid"} className={`row ${ this.props.direction }`} style={{lineHeight:"0px"}}>
          <div className="small-12 medium-4">
            <div className="three-square-image-grid-one">
              <img className="full-width background-image-fill hover-grow" src={"/images/square.png"} style={{backgroundImage: `url(${ this.props.imageTwo })`}} />
            </div>
            <div className="three-square-image-grid-two">
              <img className="full-width background-image-fill hover-grow" src={"/images/square.png"} style={{backgroundImage: `url(${ this.props.imageThree })`}} />
            </div>
          </div>
          <div className="small-12 medium-8">
            <div className="full-height full-width three-square-image-grid-three" >
              <div className="background-image-fill full-height full-width hover-grow" style={{backgroundImage: `url(${ this.props.imageOne })`}}>
                <img className="full-width show-for-small" src={"/images/square.png"} />
              </div>
            </div>
          </div>
          <img className="full-width show-for-small" style={{display:"none"}} onError={this.removeGrid} src={this.props.imageOne} />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/alpineComponents/threeSquareImageGrid/index.js